import React from 'react';

const sdgGoals = [
  {
    icon: 'https://res.cloudinary.com/dzngpgki4/image/upload/v1744984704/image_dpwkgu.png',
    text: 'End hunger, achieve food security and improved nutrition and promote sustainable agriculture',
  },
  {
    icon: 'https://res.cloudinary.com/dzngpgki4/image/upload/v1744984703/image_1642_jtqpc3.png',
    text: 'Achieve gender equality and empower all women and girls',
  },
  {
    icon: 'https://res.cloudinary.com/dzngpgki4/image/upload/v1744984704/image-1_vootwy.png',
    text: 'Promote sustained, inclusive and sustainable economic growth, full and productive employment and decent work for all',
  },
  {
    icon: 'https://res.cloudinary.com/dzngpgki4/image/upload/v1744984704/image-2_rwjuve.png',
    text: 'Build resilient infrastructure, promote inclusive and sustainable industrialization and foster innovation',
  },
  {
    icon: 'https://res.cloudinary.com/dzngpgki4/image/upload/v1744984704/image-3_jspfjb.png',
    text: 'Ensure sustainable consumption and production patterns',
  },
];

const Goals1 = [
    {
      icon: 'https://res.cloudinary.com/dzngpgki4/image/upload/v1745864537/image_rsgawt.png',
      text: 'Eradicating Poverty: By 2030, the plan aims to reduce poverty levels significantly, ensuring that all South Africans have access to basic services such as healthcare, education, housing, and sanitation.',
    },
    {
      icon: 'https://res.cloudinary.com/dzngpgki4/image/upload/v1745864536/image-1_sxqzt1.png',
      text: 'Reducing Inequality: The NDP strives to reduce income inequality by creating more economic opportunities, improving skills, and promoting social inclusion, with a target to reduce the Gini coefficient (a measure of inequality) by 2030.',
    },
    {
      icon: 'https://res.cloudinary.com/dzngpgki4/image/upload/v1745864537/image-2_qg0blm.png',
      text: 'Promoting Employment and Economic Growth: One of the central goals is to create jobs and achieve a higher economic growth rate, focusing on sectors like manufacturing, agriculture, and services.',
    },
    {
      icon: 'https://res.cloudinary.com/dzngpgki4/image/upload/v1745864537/image-3_irp4iy.png',
      text: 'Environmental Sustainability: The NDP also aims for sustainable resource management and reducing environmental degradation. This includes promoting renewable energy and green technologies, addressing climate change, and managing natural resources responsibly.',
    },
 
  ];

const Goals = () => {
  return (
    <div className="px-4 md:px-24 pt-5 md:pt-5">
      <div>
        <h1 className="text-[10px] md:text-[32px] text-[#03897B] font-bold md:-mx-2">GOALS</h1>

        <div className="flex  flex-row md:pr-10 justify-between md:items-center mt-4 md:mt-4 mb-10 md:mb-28  md:space-y-0">
          <h1 className="text-[12px] md:text-[48px] text-black font-bold">
            Sustainable development Goals SDGs
          </h1>
          <img
            src="https://res.cloudinary.com/dzngpgki4/image/upload/v1745863845/image_1717_y7yfig.png"
            alt="22"
            className="w-[40px] h-[40px] md:w-[100px] md:h-[100px]"
          />
        </div>
      </div>

      <div className="space-y-6">
        {sdgGoals.map((goal, index) => (
          <div key={index} className="flex items-start space-x-4">
            <img
              src={goal.icon}
              alt={`Goal ${index + 1}`}
              className="w-[40px] h-[40px] md:w-[129px] md:h-[129px]"
            />
            <p className="text-[12px] md:text-[38px] text-black font-medium leading-snug">
              {goal.text}
            </p>
          </div>
        ))}
      </div>

      <div className="h-[1px] md:h-[4px] rounded bg-[#979797] mt-10 md:mt-28 mb-10 md:mb-24"></div>

      <div>
        <div className="flex flex-row justify-between items-center mt-4 ">
          <h1 className="text-[10px] md:text-[48px] text-black font-bold">South Africa</h1>
          <img
            src="https://res.cloudinary.com/dzngpgki4/image/upload/v1745864548/image_1643_zyusvo.png"
            alt="22"
            className="w-[30px] h-[30px] md:w-[90px] md:h-[90px]"
          />
        </div>

        <div className="md:-mt-2 mt-1">
          <h1 className="text-[10px] md:text-[36px] font-bold text-[#979797]">
            Vision 2030 - National Development Plan (NDP)
          </h1>
        </div>

        <div className="md:mt-2">
          <p className="text-[8px] md:text-[36px] font-normal">
            <strong>The National Development Plan (NDP)</strong>, which is South Africa’s
            strategic blueprint for long-term growth, aims to eliminate poverty and reduce
            inequality by 2030. It sets out specific goals for achieving sustainable development
            in the country. Some of the key goals outlined in the NDP include:
          </p>
        </div>
      </div>

      <div className="md:space-y-10 space-y-5 md:mt-32 mt-6  md:mb-10 mb-5">
        {Goals1.map((goal, index) => (
          <div key={index} className="flex items-start md:space-x-6 space-x-4">
            <img
              src={goal.icon}
              alt={`Goal ${index + 1}`}
              className="w-[40px] h-[40px] md:w-[129px] md:h-[129px]"
            />
            <p className="text-[12px] md:text-[38px] text-black font-medium leading-snug">
              {goal.text}
            </p>
          </div>
        ))}
      </div>
    </div>
  );
};

export default Goals;
